import { render } from "./DonationsContent.vue?vue&type=template&id=d0557b52&scoped=true"
import script from "./DonationsContent.vue?vue&type=script&lang=js"
export * from "./DonationsContent.vue?vue&type=script&lang=js"

import "./DonationsContent.vue?vue&type=style&index=0&id=d0557b52&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0557b52"]])

export default __exports__